function scrollable(cont) {
  var vw = $(window).width();
  //scrollCont - это внутренний див, который будет непосредственно скроллиться
  //cont - Это внешняя обертка, она сама не скролиться, а выступает лишь в
  //       качестве обертки. Это нужно для адекватного отображения градиента,
  //       прятяющего нижнюю границу.

  var scrollCont = cont.children(".scrollable__inner");
  $(scrollCont).each(function(index){
    new PerfectScrollbar(scrollCont[index], {
      suppressScrollX: true
    });
  })

  //set shadow on bottom if needed
  if (!cont.data("no-shadow")) {
    setShadows(cont);
  }

  function setShadows(cont){
    var topShadow = $("<div></div>", {
      class:"scrollable__topShadow"
    })
    var bottomShadow = $("<div></div>", {
      class:"scrollable__bottomShadow"
    })

    /*пока просто ставим без проверки на переполнение*/

    cont.append(bottomShadow);
    topShadow.hide();
    cont.append(topShadow);


    scrollCont.each(function(){
      $(this).on("ps-y-reach-end", function () {
        $(this).closest(".js-cars-cont").find(".scrollable__bottomShadow").fadeOut(100);
      });
      $(this).on("ps-scroll-up", function () {
        $(this).closest(".js-cars-cont").find(".scrollable__bottomShadow").fadeIn(100);
      });
      $(this).on("ps-y-reach-start", function () {
        $(this).closest(".js-cars-cont").find(".scrollable__topShadow").fadeOut(100);
      });
      $(this).on("ps-scroll-down", function () {
        $(this).closest(".js-cars-cont").find(".scrollable__topShadow").fadeIn(100);
      });
    })
  }

  if (vw < 768) {
    scrollCont.css({
      "height" : $(window).outerHeight() - 105 + 'px'
    })
  }
}
